/**
 * Having a clear :focus state is important for accessibility.
 * However, it is not always aesthetically desirable on click.
 * So, we turn it on when the tab key is pressed.
 */

$(document).ready(function() {
	document.addEventListener('keydown', function(e) {
		// If tab press
		if (e.keyCode === 9) {
			$('body').removeClass('hide-focus-outlines');
		}
	});

	// We use mousedown because 'click' can be triggered by the keyboard
	document.addEventListener('mousedown', function(e) {
		$('body').addClass('hide-focus-outlines');
	});
});